import {
    isMobile,
    isMobileSafari,
    isIOS,
    getSelectorsByUserAgent
} from 'react-device-detect';
import { getWindow } from 'tradera-utils/window';
import { nullifyUndefinedProperties } from 'tradera-utils/object';
import { isSupportedMinimumVersion } from 'tradera-utils/versions';

export const getInitialServerState = ({
    query = {},
    headers = {},
    featureToggles = {},
    splitTestGroups = {}
} = {}) => {
    const debug = query.debug === '1'; // TODO: Also save in & read from session
    const userAgent = headers['user-agent'] || 'unknown';

    const {
        isMobile,
        isMobileSafari,
        isIOS,
        isAndroid
    } = getSelectorsByUserAgent(userAgent);

    const appOsVersion = headers['x-tradera-app-os-version'] || '';
    const hybridAppDevice = headers['x-tradera-app-device'] || '';
    const hybridAppVersion = headers['x-tradera-app-version'] || '';
    const isNativeAppContext = headers['x-tradera-app'] === 'Native';
    const isHybridAppContext = Boolean(headers['x-tradera-app']);
    const isHybridAppContextForAndroid = Boolean(
        isHybridAppContext && (hybridAppDevice.includes('android') || isAndroid)
    );
    const isHybridAppContextForIos = Boolean(
        isHybridAppContext &&
            (hybridAppDevice.includes('iphone') ||
                hybridAppDevice.includes('ipad') ||
                isIOS)
    );

    return {
        isHybridAppContextForAndroid, // For CSS body classes in _app
        isHybridAppContextForIos, // For CSS body classes in _app
        isNativeAppContext,
        hybridAppVersion,

        debug,
        environment: process.env.NODE_ENV,
        isHybridAppContext,
        isNativeAppWithApplyPaySupport:
            isNativeAppContext &&
            isHybridAppContextForIos &&
            isSupportedMinimumVersion(hybridAppVersion, '3.51') &&
            isSupportedMinimumVersion(appOsVersion, '13'),
        isNativeAppWithSwishCallbackSupport:
            isNativeAppContext &&
            isHybridAppContextForIos &&
            isSupportedMinimumVersion(hybridAppVersion, '3.57') &&
            isSupportedMinimumVersion(appOsVersion, '13'),
        isIOS,
        isMobileDevice: isMobile,
        isMobileSafari,
        isSpaNavigationEnabled: false, // react-router SPA navigation, never next/router
        featureSwitches: featureToggles,
        splitTestGroups
        // TODO: Fetch values for below
        // environmentHash,
        // splitTests,
        // version
    };
};

export const initEnvironment = () => {
    return nullifyUndefinedProperties({});
};

export default initData => {
    const {
        debug,
        environment,
        featureSwitches,
        isHybridAppContext,
        isNativeAppContext,
        isNativeAppWithApplyPaySupport,
        isNativeAppWithSwishCallbackSupport,
        isSinglePageApp,
        splitTests,
        splitTestGroups,
        version,
        environmentHash
    } = initData;
    return nullifyUndefinedProperties({
        debug,
        environment,
        featureSwitches,
        environmentHash,
        isHybridAppContext,
        isNativeAppWithApplyPaySupport,
        isNativeAppWithSwishCallbackSupport,
        isIOS,
        isNativeAppContext,
        isMobileDevice: isMobile,
        isMobileSafari,
        isSpaNavigationEnabled:
            isSinglePageApp && !isHybridAppContext && !getWindow().frameElement
                ? true
                : false, // No SPA navigation in native apps or iFrame
        splitTests,
        splitTestGroups,
        version
    });
};
